import { render, staticRenderFns } from "./MatchLanding.vue?vue&type=template&id=f970a168&scoped=true&"
import script from "./MatchLanding.vue?vue&type=script&lang=js&"
export * from "./MatchLanding.vue?vue&type=script&lang=js&"
import style0 from "./MatchLanding.vue?vue&type=style&index=0&id=f970a168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f970a168",
  null
  
)

export default component.exports